import React from 'react';
import { connect } from 'react-redux';
import Accessories from 'brastrap/promotional/accessories-container/AccessoriesContainer';
import Messages from 'brastrap/containers/messages/MessagesContainer';
import { addToBagAndView } from '../actions/product';
import {
  selectAccessorySku,
  selectAccessoryColour,
  updateAccessorySku,
} from '../../../actions/product';
import { openLayer, closeLayer } from '../../../actions/layer';
import BriefsSizeGuide from './modals/BriefsSizeGuideContainer';
import { addMessage, clearAllMessages } from '../../../actions/messages';

const selectAccessoryAndCloseLayer = (
  styleCode,
  sku,
  defaultStyleColourId
) => dispatch => {
  dispatch(selectAccessorySku(styleCode, sku, defaultStyleColourId));
  dispatch(closeLayer());
};

const mapStateToProps = state => {
  const product = state.product.styleColour;
  return {
    activeModal: state.layer.isVisible && state.layer.target,
    bagSkuCodes: state.bag.items
      ? state.bag.items.map(item => item.skuCode)
      : [],
    briefsSizeGuide: <BriefsSizeGuide />,
    currency: state.app.config.currency,
    disableRating: true,
    displayInline: state.browser.deviceIs.desktop,
    fetchingSku: state.bag.fetchingSku,
    id: 'accessories',
    matchingStyles: product.matchingStyles,
    MessagesComponent: Messages,
    styleColours: product.data.matchingStyleColours.styleColours,
    title: product.data.matchingStyleColours.label,
    customerDetails: state.auth.user || null,
    socialMediaChannels: state.app.config.socialMediaPixels,
    user: state.auth.user,
    basePath: state.app.config.basePath,
    locale: state.app.locale.selected,
    isDesktop: state.browser.deviceIs.desktop,
    productCategory: product.data.category,
    productGroup: product.data.productGroup,
    pdpNavigableAccessories: {
      sportsWearProductGroups:
        state.app.config.pdpNavigableAccessories.sportsWearProductGroups || '',
      swimSuitsProductGroups:
        state.app.config.pdpNavigableAccessories.swimSuitsProductGroups || '',
    },
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  onStyleColourChange: (styleColourCode, defaultStyleColourId) => {
    dispatch(selectAccessoryColour(styleColourCode, defaultStyleColourId));
    // We are removing previously selected sku as it might not be avalilable for newly selected style colour
    dispatch(updateAccessorySku(styleColourCode, defaultStyleColourId));
  },
  onSizeSelect: (styleCode, sku, defaultStyleColourId) => {
    dispatch(clearAllMessages());
    dispatch(
      selectAccessoryAndCloseLayer(styleCode, sku, defaultStyleColourId)
    );
  },
  onModalOpen: target => {
    dispatch(openLayer(target));
  },
  onModalClose: () => dispatch(closeLayer()),
});

const mergeProps = (state, dispatchProps) => ({
  ...state,
  ...dispatchProps,

  onAddToBag: (styleCode, defaultStyleColourId, error) => {
    const { dispatch } = dispatchProps;
    if (!error) {
      const style = state.matchingStyles.find(
        s =>
          s.styleCode === styleCode &&
          s.defaultStyleColourId === defaultStyleColourId
      );
      dispatch(addToBagAndView(style.sku));
    } else {
      dispatch(clearAllMessages());
      dispatch(addMessage(error.message, error.target, true));
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Accessories);
